import React from "react";
import { Routes, Route } from "react-router-dom";
import Landing from "./Landing";
import HomePage from "./HomePage";
import ContactUs from "./ContactUs";
import Room1 from "./Room1";
import Room2 from "./Room2";
import Room3 from "./Room3";
import Destination from "./Destination";
import AboutUs from "./AboutUs";

const RoutesDefined = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/noida" element={<HomePage />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/suiteroomcityview" element={<Room1 />} />
      <Route path="/suiteroompoolview" element={<Room2 />} />
      <Route path="/executivesuite" element={<Room3 />} />
      <Route path="/destination" element={<Destination />} />
      <Route path="/rishikesh" element={<Destination />} />
    </Routes>
  );
};

export default RoutesDefined;
